module.exports = __webpack_public_path__ + "media/site_templates/www.roofingcompany.net.au/images/our_services_2-4593c6c795858a3dcea936dfd50e2f92.jpg";